import { MemoryRouter, Routes, Route } from "react-router-dom";
import BookingDetails from "./BookingDetails";
import EventBooking from "./EventBooking";

const EventBookingPage = () => {
	return (
		<MemoryRouter>
			<Routes>
				<Route path="/" element={<EventBooking />} />
				<Route path="/eventBookingDetails" element={<BookingDetails />} />
			</Routes>
		</MemoryRouter>
	);
};

export default EventBookingPage;
